<div class="h1 text-primary text-center fw-bold mb-3" *ngIf="!otpToken">
  Verify Your Identity
</div>

<div class="h1 text-primary text-center fw-bold mb-3" *ngIf="otpToken">
  Complete Your Profile
</div>

<div class="text-center mb-4" *ngIf="!otpToken">
  <p class="mb-2">We found your account. Enter the 6-digit code sent to {{email}}.</p>

  <div *ngIf="globalError" class="text-danger mb-2">{{globalError}}</div>

  <div class="mb-3">
    <input id="otpCode"
           type="text"
           inputmode="numeric"
           maxlength="6"
           class="form-control text-center"
           [value]="otpCode"
          (input)="onOtpInput($event)"
           placeholder="Verification Code">
    <div class="small text-danger mt-1" *ngIf="otpError">{{otpError}}</div>
  </div>

  <div class="mb-3">
    <button type="button" class="btn btn-primary w-100"
            [disabled]="otpCode.length !== otpLength || otpVerifyInProgress"
            (click)="verifyOtp()">
      {{otpVerifyInProgress ? 'Verifying...' : 'Verify'}}
    </button>
  </div>

  <div class="mb-4 text-end">
    <button type="button" class="btn btn-link p-0"
            [disabled]="resendCooldown > 0 || otpSendInProgress"
            (click)="resendOtp()">
      {{resendCooldown > 0 ? ('Resend in ' + resendCooldown + 's') : 'Resend code'}}
    </button>
  </div>

  <div class="mb-4 text-center">
    <button type="button" class="btn btn-outline-primary w-100" (click)="goBack()">Go Back</button>
  </div>
</div>

<form class="mt-4" *ngIf="otpToken" [formGroup]="completionForm" (ngSubmit)="completeAccount()">
  <div *ngIf="globalError" class="text-danger text-center mb-3">{{globalError}}</div>

  <div class="mb-3">
    <input id="completionEmail" type="email" class="form-control" [value]="email" readonly>
  </div>

  <div class="mb-3">
    <input id="completionLastName" type="text" class="form-control" formControlName="lastName"
           placeholder="Last Name">
    <ua-display-validation-errors name='Last name' [control]="completionForm.controls.lastName" [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3">
    <input id="completionPhoneNumber" type="tel" class="form-control" formControlName="phoneNumber"
           placeholder="Phone Number">
    <ua-display-validation-errors name='Phone number' [control]="completionForm.controls.phoneNumber" [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3">
    <input id="completionDateOfBirth" type="date" class="form-control" formControlName="dateOfBirth"
           placeholder="Date of Birth">
    <ua-display-validation-errors name='Date of birth' [control]="completionForm.controls.dateOfBirth" [force]="formDirty">
    </ua-display-validation-errors>
    <div class="small text-danger"
         *ngIf="completionForm.controls.dateOfBirth.errors?.underAge && (formDirty || completionForm.controls.dateOfBirth.touched)">
      You must be at least 18 years old.
    </div>
    <div class="small text-danger"
         *ngIf="completionForm.controls.dateOfBirth.errors?.invalidDateOfBirth && (formDirty || completionForm.controls.dateOfBirth.touched)">
      Please enter a valid date of birth.
    </div>
  </div>

  <div class="row g-2 mb-2">
    <div class="col">
      <input id="completionPassword" type="password" class="form-control" formControlName="password"
             placeholder="Password">
      <ua-display-validation-errors name='Password' [control]="completionForm.controls.password" [force]="formDirty">
      </ua-display-validation-errors>
    </div>
    <div class="col">
      <input id="completionConfirmPassword" type="password" class="form-control" formControlName="confirmPassword"
             placeholder="Confirm Password">
      <ua-display-validation-errors name='Confirmation' [control]="completionForm.controls.confirmPassword" [force]="formDirty">
      </ua-display-validation-errors>
    </div>
  </div>

  <div class="mb-3">
    <ua-display-validation-errors name='Passwords' [control]="completionForm" [force]="formDirty">
    </ua-display-validation-errors>
  </div>

  <div class="mb-3">
    <button type="submit" class="btn btn-primary w-100" [disabled]="completionInProgress">
      {{completionInProgress ? 'Completing profile...' : 'Complete Profile'}}
    </button>
  </div>

  <div class="mb-4 text-center">
    <button type="button" class="btn btn-outline-primary w-100" (click)="goBack()">Go Back</button>
  </div>
</form>
